/* Samila Home - search behaviour shared by the mega menu, the home banner
   and the full-screen overlay.

   Destinations (collections + tags) come from an index rendered once by
   samila-search-data. Products come live from Shopify's predictive search.
   Tag counts are fetched from /collections/all/<tag>?view=count and cached
   for the session. */
(function () {
  'use strict';

  function readJSON(id, fallback) {
    var el = document.getElementById(id);
    if (!el) return fallback;
    try { return JSON.parse(el.textContent) || fallback; } catch (e) { return fallback; }
  }

  var COLS   = readJSON('ShSearchCollections', []);
  var TAGS   = readJSON('ShSearchTags', []);
  var ROUTES = readJSON('ShSearchRoutes', { search: '/search', all: '/collections/all' });
  var ALL    = String(ROUTES.all || '/collections/all').replace(/\/$/, '');

  var counts = {};
  try { counts = JSON.parse(sessionStorage.getItem('shTagCounts')) || {}; } catch (e) {}
  function remember(h, n) {
    counts[h] = n;
    try { sessionStorage.setItem('shTagCounts', JSON.stringify(counts)); } catch (e) {}
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function mark(text, term) {
    var i = String(text).toLowerCase().indexOf(term);
    if (i < 0) return esc(text);
    return esc(text.slice(0, i)) + '<b>' + esc(text.slice(i, i + term.length)) + '</b>' + esc(text.slice(i + term.length));
  }

  function rank(list, term) {
    var starts = [], has = [];
    for (var i = 0; i < list.length; i++) {
      var p = String(list[i].t).toLowerCase().indexOf(term);
      if (p === 0) starts.push(list[i]);
      else if (p > 0) has.push(list[i]);
    }
    return { starts: starts, has: has };
  }

  function plural(n) { return n + ' poster' + (n === 1 ? '' : 's'); }
  function tagUrl(h) { return ALL + '/' + h; }

  // ---------------------------------------------------------------- products
  var productCache = {};

  // Shopify's predictive endpoint stops at ten products. templates/
  // search.sh_quick.liquid answers the same query from the search index and
  // gives back up to 24 plus the real total, so that is tried first; the
  // predictive endpoint stays as the fallback if it is ever unavailable.
  function fetchSuggest(term, limit) {
    var url = ROUTES.search + '/suggest.json?q=' + encodeURIComponent(term) +
              '&resources[type]=product&resources[limit]=' + limit +
              '&resources[options][unavailable_products]=last';
    return fetch(url)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        var items = [];
        try { items = data.resources.results.products || []; } catch (e) {}
        return { items: items, count: 0 };
      })
      .catch(function () { return { items: [], count: 0 }; });
  }

  function fetchProducts(term, limit) {
    if (productCache[term]) return Promise.resolve(productCache[term]);
    var url = ROUTES.search + '?q=' + encodeURIComponent(term) +
              '&type=product&options%5Bprefix%5D=last&view=sh_quick';
    return fetch(url)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data || !data.items || !data.items.length) throw new Error('empty');
        var out = {
          items: data.items.map(function (p) {
            return { title: p.title, url: p.url, price: p.price,
                     featured_image: { url: p.image } };
          }),
          count: data.count || data.items.length
        };
        productCache[term] = out;
        return out;
      })
      .catch(function () {
        return fetchSuggest(term, limit).then(function (out) {
          if (out.items.length) productCache[term] = out;
          return out;
        });
      });
  }

  // -------------------------------------------------------------- one widget
  function Search(root) {
    if (root.dataset.shBound) return;
    root.dataset.shBound = '1';

    var variant = root.dataset.shVariant || 'mega';
    var input   = root.querySelector('[data-sh-search-input]');
    var panel   = root.querySelector('[data-sh-search-panel]');
    var side    = root.querySelector('[data-sh-search-side]');
    var main    = root.querySelector('[data-sh-search-main]');
    var allLink = root.querySelector('[data-sh-search-all]');
    var clear   = root.querySelector('[data-sh-search-clear]');
    var timer, token = 0;

    function open()  { panel.hidden = false; root.classList.add('is-open'); }
    function close() { panel.hidden = true;  root.classList.remove('is-open'); }
    function showClear() { if (clear) clear.hidden = !input.value; }

    function countCell(handle, probe) {
      var known = counts[handle];
      return '<span class="sh-search__count' + (known === undefined ? ' is-loading' : '') + '"' +
             ' data-sh-count="' + esc(handle) + '"' + (probe ? ' data-sh-probe="1"' : '') + '>' +
             (known === undefined ? '&middot;&middot;&middot;' : plural(known)) + '</span>';
    }

    function renderDestinations(term) {
      var c = rank(COLS, term);
      var bySize = function (a, b) { return b.n - a.n; };
      c.starts.sort(bySize); c.has.sort(bySize);
      var colHits = c.starts.concat(c.has).slice(0, 5);

      var t = rank(TAGS, term);
      var tagHits = t.starts.concat(t.has).slice(0, 6);

      // the tag list is capped at 1000, so always ask the shop about the
      // typed word itself as well
      var typed = term.replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
      if (typed && counts[typed] !== 0 && !tagHits.some(function (x) { return x.h === typed; })) {
        tagHits.unshift({ t: term, h: typed, probe: true });
      }

      var html = '';
      if (colHits.length) {
        html += '<p class="sh-search__lead">Collections</p><ul class="sh-search__list">';
        colHits.forEach(function (c) {
          html += '<li><a href="' + esc(c.u) + '"><span class="sh-search__name">' + mark(c.t, term) +
                  '</span><span class="sh-search__count">' + plural(c.n) + '</span></a></li>';
        });
        html += '</ul>';
      }
      if (tagHits.length) {
        html += '<p class="sh-search__lead">Tags</p><ul class="sh-search__list">';
        tagHits.forEach(function (t) {
          html += '<li><a href="' + esc(tagUrl(t.h)) + '"><span class="sh-search__name">' + mark(t.t, term) +
                  '</span>' + countCell(t.h, t.probe) + '</a></li>';
        });
        html += '</ul>';
      }
      if (!colHits.length && !tagHits.length) {
        html += '<p class="sh-search__lead">No collection or tag matches</p>';
      }
      side.innerHTML = html;

      side.querySelectorAll('[data-sh-count].is-loading').forEach(function (el) {
        loadCount(el.getAttribute('data-sh-count'), el);
      });
    }

    function loadCount(handle, el) {
      if (counts[handle] !== undefined) { paint(el, counts[handle]); return; }
      fetch(tagUrl(handle) + '?view=count')
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (txt) {
          if (txt === null) { giveUp(el); return; }
          var n = parseInt(String(txt).replace(/[^0-9]/g, ''), 10);
          if (isNaN(n)) { giveUp(el); return; }
          remember(handle, n);
          if (n === 0) { drop(el); return; }
          paint(el, n);
        })
        .catch(function () { giveUp(el); });
    }
    function paint(el, n) { el.textContent = plural(n); el.classList.remove('is-loading'); }
    function giveUp(el) {
      if (el.getAttribute('data-sh-probe') === '1') { drop(el); return; }
      el.textContent = ''; el.classList.remove('is-loading');
    }
    function drop(el) {
      var row = el.closest('li'), list = row && row.parentElement;
      if (row) row.remove();
      if (list && !list.children.length) {
        var lead = list.previousElementSibling;
        if (lead && lead.classList.contains('sh-search__lead')) lead.remove();
        list.remove();
      }
    }

    function renderProducts(term, mine) {
      main.innerHTML = '<p class="sh-search__lead">Posters</p>' +
                       '<div class="sh-search__grid is-waiting">' +
                       new Array(8).join('<span class="sh-search__ghost"></span>') +
                       '</div>';
      fetchProducts(term, 10).then(function (res) {
        var items = res.items || [];
        var total = res.count || items.length;
        if (mine !== token) return;              // a newer keystroke won already
        if (!items.length) {
          main.innerHTML = '<p class="sh-search__lead">Posters</p>' +
                           '<p class="sh-search__none">Nothing matches &ldquo;' + esc(term) + '&rdquo; yet.</p>';
          return;
        }
        var shown = items.length;
        var lead = 'Posters';
        if (total > shown) lead += ' <span class="sh-search__leadCount">' + shown + ' of ' + total + '</span>';
        else if (shown) lead += ' <span class="sh-search__leadCount">' + shown + '</span>';
        var html = '<p class="sh-search__lead">' + lead + '</p><div class="sh-search__grid">';
        items.forEach(function (p) {
          var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
          html += '<a class="sh-search__card" href="' + esc(p.url) + '">' +
                    '<span class="sh-search__thumb">' +
                      (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') +
                    '</span>' +
                    '<span class="sh-search__ptitle">' + esc(p.title) + '</span>' +
                    '<span class="sh-search__price">' + esc(p.price || '') + '</span>' +
                  '</a>';
        });
        html += '</div>';
        main.innerHTML = html;
      });
    }

    function render(term) {
      if (term.length < 2) { close(); return; }
      token++;
      var mine = token;
      renderDestinations(term);
      renderProducts(term, mine);
      allLink.href = ROUTES.search + '?q=' + encodeURIComponent(term) + '&type=product';
      allLink.innerHTML = 'See every poster for &ldquo;' + esc(term) + '&rdquo; <span aria-hidden="true">&rarr;</span>';
      open();
    }

    input.addEventListener('input', function () {
      clearTimeout(timer);
      showClear();
      var term = input.value.trim().toLowerCase();
      timer = setTimeout(function () { render(term); }, 130);
    });

    input.addEventListener('focus', function () {
      var term = input.value.trim().toLowerCase();
      if (term.length < 2) return;
      if (side.innerHTML || main.innerHTML) open(); else render(term);
    });

    input.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      e.preventDefault();                       // type="search" would wipe the term
      if (!panel.hidden) { close(); return; }
      var ov = root.closest('[data-sh-overlay]');
      if (ov) window.ShSearchOverlay.close(); else input.blur();
    });

    if (clear) {
      clear.addEventListener('click', function () {
        input.value = ''; side.innerHTML = ''; main.innerHTML = '';
        close(); showClear(); input.focus();
      });
    }

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) close();
    });
    document.addEventListener('focusin', function (e) {
      if (!root.contains(e.target) && !root.closest('[data-sh-overlay]')) close();
    });

    showClear();
    root.shRender = render;
    root.shInput = input;
  }

  // ---------------------------------------------------------------- overlay
  var Overlay = {
    el: null,
    lastFocus: null,
    open: function () {
      this.el = this.el || document.querySelector('[data-sh-overlay]');
      if (!this.el) return;
      this.lastFocus = document.activeElement;
      this.el.hidden = false;
      document.documentElement.classList.add('sh-overlay-open');
      // let the class land before transitioning
      requestAnimationFrame(function () { Overlay.el.classList.add('is-open'); });
      var box = this.el.querySelector('[data-sh-search-input]');
      if (box) setTimeout(function () { box.focus(); }, 60);
    },
    close: function () {
      if (!this.el) return;
      this.el.classList.remove('is-open');
      document.documentElement.classList.remove('sh-overlay-open');
      var el = this.el;
      setTimeout(function () { el.hidden = true; }, 260);
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
    }
  };
  window.ShSearchOverlay = Overlay;

  function bindAll() {
    document.querySelectorAll('[data-sh-search]').forEach(Search);
  }

  function init() {
    bindAll();

    // take over the theme's magnifying glass, on desktop and mobile
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('.header__icon--search, [data-search-menu], [data-search-mobile]');
      if (!trigger) return;
      if (trigger.closest('[data-sh-overlay]')) return;
      e.preventDefault();
      e.stopPropagation();
      var d = trigger.closest('details');
      if (d) d.removeAttribute('open');
      Overlay.open();
    }, true);

    var ov = document.querySelector('[data-sh-overlay]');
    if (ov) {
      ov.addEventListener('click', function (e) {
        if (e.target.hasAttribute('data-sh-overlay-close') ||
            e.target.closest('[data-sh-overlay-close]')) {
          e.preventDefault();
          Overlay.close();
        }
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && ov && !ov.hidden) Overlay.close();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
